import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private toastConfig: Partial<IndividualConfig> = {
    progressBar: true,
    timeOut: 3000,
    positionClass: 'toast-top-right'
  };

  constructor(private toastr: ToastrService) {}

  successToaster(text: string, timeOut: number = this.toastConfig.timeOut as number) {
    this.toastr.success(text, '', {
      ...this.toastConfig,
      timeOut,
      toastClass: 'ngx-toastr custom-success-toast'
    });
  }

  warningToaster(text: string) {
    this.toastr.warning(text, '', {
      ...this.toastConfig,
      toastClass: 'ngx-toastr custom-warning-toast'
    });
  }

  errorToaster(text: string) {
    this.toastr.error(text, '', {
      ...this.toastConfig,
      toastClass: 'ngx-toastr custom-error-toast'
    });
  }

  errorToasterAutoClose(text: string) {
    this.toastr.error(text, '', {
      ...this.toastConfig,
      timeOut: 5000
    });
  }


  confirmationPopup(title: string, confirmButtonText: string = 'Yes', cancelButtonText: string = 'No') {
    return Swal.fire({
      title,
      icon: 'question',
      background: 'var(--white-constant)',
      color: 'var(--dark-black)',
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: 'var(--dark-gray)',
      confirmButtonText,
      cancelButtonText
    });
  }

  priorDownloadConfirmationPopup(
    title: string = 'Are you sure you want to download?',
    text?: string
  ) {
    return this.confirmationPopup(title, text);
  }

  customConfirmationPopup(
    title: string,
    confirmButtonText: string,
    cancelButtonText: string
  ) {
    return Swal.fire({
      title,
      icon: 'question',
      background: 'var(--alert-popup-bg)',
      color: 'var(--black-text)',
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: 'var(--reset-button-bg)',
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick: false
    });
  }

  infoPopup(title: string, text?: string) {
    return Swal.fire({
      title,
      text,
      icon: 'info',
      background: 'var(--white-original)',
      color: 'var(--dark-black)',
      confirmButtonColor: 'var(--primary)',
      confirmButtonText: 'Ok'
    });
  }
}
